import type { I18nDict } from '../types.ts'

export const nl: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Instellingen',
  section_language: 'Taal',
  section_identity: 'Lokale identiteit',
  section_updates: 'App-update',
  section_notifications: 'Meldingen',
  section_theme: 'Visueel thema',
  section_backup: 'Chatback-up',
  section_privacy_network: 'Netwerkprivacy',
  section_media: 'Multimedia',
  section_security: 'Beveiliging & wachtwoord',
  section_exit: 'Afsluiten & gegevens wissen',
  toggle_external_links: 'Externe links ontvangen en bekijken',
  hint_external_links: 'Bij UIT: geen linkvoorbeelden in chat en externe URL\'s kunnen niet worden geopend (bescherming tegen IP-tracking).',
  toggle_auto_media: 'Automatisch media en documenten downloaden',
  hint_auto_media: 'Bij UIT: foto\'s, video\'s en bestanden worden niet op de achtergrond gedownload — tik handmatig in de chat.',
  toggle_require_unlock: 'Wachtwoord bij openen app',
  hint_require_unlock: 'Bij AAN is het hoofdwachtwoord elke keer vereist wanneer je ZION opent.',
  toggle_wipe_exit: 'Gegevens wissen bij afsluiten',
  hint_wipe_exit: 'Bij AAN worden bij het sluiten van de app tijdelijke RAM-cache en sessiegegevens gewist.',
  btn_exit: 'Afsluiten',
  btn_delete_all: 'ALLE GEGEVENS WISSEN',
  btn_lock: 'App vergrendelen',
  btn_back: 'Terug',
  warn_disable_password_title: '⚠️ WAARSCHUWING',
  warn_disable_password_body: 'Als je het openwachtwoord uitschakelt, kan iedereen met toegang tot je apparaat je versleutelde berichten lezen. Weet je zeker dat je wilt doorgaan?',
  warn_delete_all_1: 'Wil je echt de volledige database vernietigen? Deze actie is onomkeerbaar.',
  warn_delete_all_2: 'Laatste bevestiging: alle chats, privésleutels en instellingen worden permanent verwijderd.',
  link_blocked: 'Externe link geblokkeerd (privacy-instellingen).',
  lang_welcome_title: 'Welkom bij ZION',
  lang_welcome_sub: 'Kies je taal',
  lang_continue: 'Doorgaan',
  settings_language_label: 'Apptaal',
  auth_unlock_title: 'Ontgrendelen',
  auth_or_password: '— of ontgrendelen met wachtwoord —',
  auth_password_master: 'Hoofdwachtwoord',
  auth_unlock_btn: 'Ontgrendelen',
  auth_verifying: 'Controleren…',
  auth_wrong_password: 'Onjuist wachtwoord',
  auth_unlocked: 'Ontgrendeld ✓',
  auth_access_title: 'Deelnemen aan ZION',
  auth_beta_spots: 'Gratis bèta · plaatsen over:',
  auth_beta_full: 'Bèta vol ({max} gebruikers). Probeer het later opnieuw.',
  auth_beta_free: 'Gratis bèta · geen licentie vereist',
  auth_or_create: '— of een nieuwe identiteit aanmaken —',
  auth_password_min: 'Wachtwoord (min. 8 tekens)',
  auth_password_confirm: 'Wachtwoord bevestigen',
  auth_privacy_check: 'Ik heb het',
  auth_privacy_link: 'Privacybeleid',
  auth_terms_check: 'Ik accepteer de',
  auth_terms_link: 'Gebruiksvoorwaarden',
  auth_password_local_hint: 'Het wachtwoord verlaat dit apparaat nooit. Geen serveraccount.',
  auth_create_identity: 'Identiteit aanmaken',
  auth_accept_legal_err: 'Accepteer Privacy en Gebruiksvoorwaarden om door te gaan',
  auth_generating_keys: 'Sleutels en sessie genereren…',
  auth_generating_identity: 'Anonieme identiteit genereren…',
  auth_generating_detail: 'ECDH-sleutels · bijnaam · socket-sessie · ZN- code',
  auth_you_are: 'Je bent',
  auth_daily_suffix_hint: 'Het dagelijkse achtervoegsel wijzigt elke UTC-dag. Gebruik voor koppelen de ZN- code op Home.',
  auth_enter: 'ZION openen',
  auth_starting: 'Starten…',
  auth_restore_title: 'Back-up herstellen',
  auth_restore_hint: 'Heb je al een versleutelde back-up? Herstel identiteit, contacten en chats (bijv. na het wissen van de cache).',
  auth_restore_file: 'Back-upbestand (.enc / .enc.json)',
  auth_restore_pass: 'Back-upwachtwoord',
  auth_restore_pass_ph: 'Wachtwoord gebruikt bij export',
  auth_restore_btn: 'Back-up herstellen',
  auth_restore_pick_file: 'Selecteer een back-upbestand (.enc of .enc.json).',
  auth_restore_need_pass: 'Voer het wachtwoord in.',
  auth_restoring: 'Herstellen…',
  auth_file_prefix: 'Bestand:',
  common_accept: 'Accepteren',
  common_reject: 'Weigeren',
  common_cancel: 'Annuleren',
  common_accepting: 'Accepteren…',
  common_error: 'Fout',
  common_loading: 'Laden…',
  common_send: 'Verzenden',
  common_copied: 'Gekopieerd ✓',
  common_copy_failed: 'Kopiëren mislukt',
  common_ok: 'OK',
  common_today: 'Vandaag',
  common_yesterday: 'Gisteren',
  common_sending: 'Verzenden…',
  home_zn_midnight_hint: 'Wijzigt om UTC-middernacht (over {h}u {m}m)',
  home_temp_empty: 'Geen tijdgebonden chats. Tik ⏱ bij een contact om er een te starten.',
  home_unread_aria: '{count} berichten',
  home_temp_waiting: 'Wachten op acceptatie…',
  home_temp_expires: 'Tijdgebonden chat · verloopt over {remaining}',
  home_temp_cancel: 'Annuleren',
  home_temp_fallback_label: 'tijdgebonden chat',
  home_temp_invite_title: '⏱ Uitnodiging voor tijdgebonden chat',
  home_temp_invite_body: '{nick} wil een vergankelijke chat ({duration}).',
  home_temp_invite_hint: 'Accepteer om berichten uit te wisselen die bij verloop verdwijnen.',
  home_temp_accept: 'Accepteren',
  home_temp_reject: 'Weigeren',
  home_temp_accepting: 'Accepteren…',
  home_contacts_empty: 'Geen contacten. Deel je ZN- code of QR om te koppelen.',
  home_temp_chat_aria: 'Tijdgebonden chat',
  home_btn_pair_title: 'Koppelen',
  home_btn_settings_title: 'Instellingen',
  home_zn_title: 'ZN- code van vandaag',
  home_btn_copy_zn: 'ZN- kopiëren',
  home_btn_open_pair: 'Koppelings-QR',
  home_section_temp: 'Tijdgebonden chats',
  home_section_chat: 'Chats',
  home_loading: 'Laden…',
  home_pair_zn_title: 'Koppelen met ZN- code',
  home_btn_zn_pair: 'Verzoek verzenden',
  home_copied: 'Gekopieerd ✓',
  home_copy_failed: 'Kopiëren mislukt',
  home_pair_request_title: 'Contactverzoek',
  home_pair_request_body: '{name} wil chatten.',
  home_pair_reject: 'Weigeren',
  home_pair_accept: 'Accepteren',
  home_pair_accepting: 'Accepteren…',
  home_pair_accept_failed: 'Accepteren mislukt',
  home_zn_digits_err: 'Voer de 5 cijfers na ZN- in.',
  home_sending: 'Verzenden…',
  chat_rename: 'Hernoemen',
  chat_rename_matrix: '[HERNOEMEN]',
  chat_rename_title: 'Contact hernoemen',
  chat_menu_title: 'Chatopties',
  chat_loading: 'Berichten laden…',
  chat_reply_to: 'Antwoorden aan',
  chat_cancel_title: 'Annuleren',
  chat_voice_lock_hint: 'Veeg omhoog om opname te vergrendelen',
  chat_voice_locked: 'Opname vergrendeld — tik op Klaar',
  chat_voice_stop: 'KLAAR',
  chat_voice_stop_title: 'Klaar',
  chat_voice_preview_label: 'Spraakvoorbeeld — beluister voor verzenden',
  chat_voice_send: 'VERZENDEN',
  chat_voice_send_title: 'Verzenden',
  chat_timer_label: 'Timer',
  chat_timer_title: 'Berichtentimer',
  chat_timer_off: 'UIT',
  chat_timer_15s: '15s',
  chat_timer_30s: '30s',
  chat_timer_1m: '1m',
  chat_timer_2m: '2m',
  chat_photo: 'Foto',
  chat_photo_title: 'Foto',
  chat_voice_hold: 'Ingedrukt houden om op te nemen',
  chat_voice_hold_title: 'Ingedrukt houden om op te nemen',
  chat_doc: 'Doc',
  chat_doc_title: 'Document',
  chat_attach_title: 'Bijlagen',
  chat_input_placeholder: 'E2E-versleuteld bericht…',
  chat_send: 'Verzenden',
  chat_rename_modal_title: 'Contact hernoemen',
  chat_rename_nickname: 'Bijnaam: @{nick}',
  chat_rename_placeholder: 'Aangepaste naam',
  chat_rename_cancel: 'Annuleren',
  chat_rename_save: 'Opslaan',
  chat_action_reply: '↩ Beantwoorden',
  chat_action_copy: '⎘ Kopiëren',
  chat_action_delete_me: '🗑 Verwijderen voor mij',
  chat_action_delete_all: '🗑 Verwijderen voor iedereen',
  chat_action_cancel: 'Annuleren',
  chat_menu_clear_me: '🗑 Chat wissen (alleen voor mij)',
  chat_menu_clear_all: '🗑 Chat verwijderen voor iedereen',
  chat_menu_cancel: 'Annuleren',
  chat_doc_send_title: 'Document verzenden',
  chat_doc_default_name: 'document',
  chat_doc_send_hint: 'Het bestand wordt gecomprimeerd, E2E-versleuteld en verzonden. Max. 5 MB.',
  chat_doc_cancel: 'Annuleren',
  chat_doc_send_encrypted: 'Versleuteld verzenden',
  chat_doc_too_large: '⚠️ BESTAND TE GROOT: De maximale beveiligingslimiet voor documenten is 5 MB.',
  chat_doc_unsupported: 'Niet-ondersteund documenttype.',
  chat_copy_failed: 'Kopiëren mislukt',
  chat_confirm_delete_me: 'Dit bericht alleen voor jou verwijderen?',
  chat_confirm_delete_all: 'Dit bericht voor iedereen verwijderen?',
  chat_confirm_clear_all: 'De volledige chat voor iedereen verwijderen? Deze actie is onomkeerbaar.',
  chat_confirm_clear_me: 'De chat alleen voor jou wissen?',
  chat_jump_new: '↓ Nieuwe berichten',
  chat_empty: 'Geen berichten. Schrijf iets om te beginnen.',
  chat_voice_err_short: 'Spraakbericht te kort (minimaal 1 seconde).',
  chat_voice_err_long: 'Spraakbericht te lang (maximaal 2 minuten).',
  chat_voice_err_large: 'Spraakbericht te groot (max. 3 MB).',
  chat_voice_err_start: 'Spraakopname kon niet worden gestart.',
  chat_destroyed: '✉ Bericht gelezen en vernietigd',
  chat_destroyed_title: 'Bericht gelezen en vernietigd',
  chat_hold_options: 'Ingedrukt houden voor opties',
  chat_reply_fallback: 'Bericht',
  chat_timer_badge: '⏱ {seconds}s',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'De ZN- code wijzigt om UTC-middernacht (over {h}u {m}m).',
  pair_copied: 'Gekopieerd ✓',
  pair_copy_failed: 'Kopiëren mislukt',
  pair_title: 'Koppelen',
  pair_zn_title: 'Je ZN- code vandaag',
  pair_btn_copy_zn: 'ZN- code kopiëren',
  pair_tab_mine: 'Mijn QR',
  pair_tab_scan: 'Scannen / ZN-',
  pair_qr_aria: 'Koppelings-QR',
  pair_expires_in: 'Verloopt over',
  pair_btn_copy_payload: 'Payload kopiëren',
  pair_btn_regen_qr: 'QR opnieuw genereren',
  pair_qr_hint: 'Toon deze QR aan het andere apparaat. 10 minuten geldig — compatibel met de Android-app.',
  pair_expired: 'verlopen',
  pair_contact_zn_title: 'ZN- code van contact',
  pair_zn_prefix_hint: 'Het voorvoegsel <strong>ZN-</strong> is al ingesteld — voer alleen de 5 letters/cijfers in.',
  pair_btn_zn_request: 'ZN- verzoek verzenden',
  pair_paste_title: 'Of plak een ZION1:: QR',
  pair_paste_hint: 'Plak een <code>ZION1::</code> payload of upload een foto van de QR.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'Van foto / camera',
  pair_btn_connect_qr: 'Verbinden met QR',
  pair_zn_digits_err: 'Voer de 5 cijfers na ZN- in.',
  pair_sending: 'Verzoek verzenden…',
  pair_reading_qr: 'QR lezen…',
  pair_qr_not_found: 'QR-code niet gevonden in de afbeelding.',
  pair_zn_read_ok: 'ZN- code gelezen — bevestig met Verzoek verzenden.',
  pair_qr_read_ok: 'QR gelezen — bevestig met Verbinden met QR.',
  pair_qr_read_err: 'Fout bij het lezen van QR.',
  settings_identity_hint: 'Wachtwoord en sleutels blijven in deze browser. Geen serveraccount.',
  settings_btn_add_home: 'Handleiding toevoegen aan startscherm',
  settings_devices_title: 'Gekoppelde apparaten',
  settings_devices_hint: 'Multi-device Zero-Knowledge: sleutels worden E2E-versleuteld overgedragen. De server is alleen een relay.',
  settings_btn_link_device: 'Nieuw apparaat koppelen',
  settings_btn_sync_pc: 'PC-geschiedenis synchroniseren',
  settings_no_devices: 'Geen gekoppelde apparaten.',
  settings_device_self: 'dit apparaat',
  settings_version_prefix: 'Versie:',
  settings_ios_push_hint: '<strong>iPhone:</strong> meldingen = PWA vanaf startscherm + Banner/Geluid AAN. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'App-update forceren',
  settings_updating: 'Bijwerken…',
  settings_push_mode_prefix: 'Modus:',
  settings_push_hint_ios: '<strong>iPad/iPhone:</strong> meldingen werken alleen wanneer je ZION opent via het startschermpictogram (Delen → Zet op startscherm). In gewone Safari zijn ze <em>niet</em> beschikbaar — zelfs niet op iOS 17. Na installatie op het startscherm, kom hier terug en tik op Meldingen inschakelen.',
  settings_btn_enable_push: 'Pushmeldingen inschakelen',
  settings_btn_desktop_notify: 'Desktopmeldingen (PC)',
  settings_btn_disable_push: 'Meldingen uitschakelen',
  settings_desktop_requesting: 'Desktopmachtiging aanvragen…',
  settings_desktop_ok: 'Desktopmeldingen actief (geluid + pop-up bij nieuw bericht).',
  settings_desktop_denied: 'Machtiging geweigerd of niet ondersteund.',
  settings_push_no_session: 'Sessie niet gereed.',
  settings_push_requesting: 'Machtiging aanvragen…',
  settings_push_active: 'Meldingen actief.',
  settings_push_disabled: 'Meldingen uitgeschakeld.',
  settings_theme_hint: 'Dezelfde thema\'s als in de ZION Android-app.',
  settings_theme_recommended: 'Aanbevolen',
  settings_backup_hint: 'JSON-bestand versleuteld met een wachtwoord (compatibel met Android v2-formaat). Bewaar het op je PC: contacten, chats en webidentiteit.',
  settings_backup_pass_label: 'Back-upwachtwoord',
  settings_backup_pass_ph: 'Eigen wachtwoord (min. 8 tekens)',
  settings_btn_export_backup: 'Back-up exporteren',
  settings_backup_file_label: 'Herstellen vanuit bestand',
  settings_backup_import_pass_label: 'Back-upwachtwoord',
  settings_backup_import_pass_ph: 'Wachtwoord gebruikt bij export',
  settings_btn_import_backup: 'Back-up herstellen',
  settings_backup_file_prefix: 'Bestand: {name}',
  settings_backup_pass_min: 'Wachtwoord moet minimaal 8 tekens bevatten.',
  settings_backup_creating: 'Back-up maken…',
  settings_backup_pick_file: 'Selecteer een back-upbestand (.enc of .enc.json).',
  settings_backup_need_pass: 'Voer het back-upwachtwoord in.',
  settings_backup_restoring: 'Herstellen…',
  settings_backup_overwrite_confirm: 'Lokale gegevens overschrijven?',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 minuten',
  temp_duration_10m: '10 minuten',
  temp_duration_15m: '15 minuten',
  temp_duration_30m: '30 minuten',
  temp_duration_1h: '1 uur',
  temp_duration_6h: '6 uur',
  temp_duration_24h: '24 uur',
  temp_duration_7d: '7 dagen',
  temp_remaining_expired: 'Verlopen',
  temp_remaining_days: '{days}d {hours}u',
  temp_remaining_hours: '{hours}u {minutes}m',
  temp_remaining_minutes: '{minutes}m',
  temp_remaining_seconds: '{seconds}s',
  temp_screen_subtitle: 'Tijdgebonden chat · vergankelijke berichten',
  temp_empty: 'Geen vergankelijke berichten.',
  temp_empty_hint: 'Schrijf een vergankelijk bericht. Het verdwijnt wanneer de timer afloopt.',
  temp_input_placeholder: 'Vergankelijk bericht…',
  temp_send: 'Verzenden',
  temp_waiting_accept: 'Wachten tot {name} de tijdgebonden chat accepteert…',
  temp_waiting_placeholder: 'Wachten op acceptatie…',
  temp_expires_in: 'Verloopt over {remaining}',
  temp_duration_title: 'Tijdgebonden chat',
  temp_duration_with: 'Met {name}',
  temp_duration_hint: 'Kies de duur — de chat verdwijnt van beide apparaten.',
  temp_sending_invite: 'Uitnodiging verzenden…',
  voice_lock_hint: 'Veeg omhoog om opname te vergrendelen',
  voice_locked: 'Opname vergrendeld — tik op Klaar',
  add_home_title: 'Toevoegen aan startscherm (iPhone / iPad)',
  add_home_guide_title: 'Safari-handleiding',
  add_home_step1: 'Open <strong>Safari</strong> op deze pagina (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Tik op <strong>Delen</strong> (vierkant met pijl omhoog)',
  add_home_step3: 'Kies <strong>Zet op startscherm</strong>',
  add_home_step4: 'Open ZION via het <strong>pictogram</strong> — niet via een Safari-tabblad',
  add_home_hint: 'Op iOS/iPadOS 16.4+ ondersteunt de startscherm-app Web Push-meldingen en het chattoetsenbord. Na installatie ga naar <strong>Instellingen → Meldingen inschakelen</strong>.',
  add_home_btn_continue: 'Begrepen — doorgaan',
  add_home_btn_skip: 'Nu overslaan',
  search_title: 'Zoeken met ZN- code',
  search_label: 'Dagelijkse ZN- code',
  search_placeholder: 'ZN-123456',
  search_btn: 'Zoeken',
  search_hint: 'Voer de ZN- code van het contact in. Geen bijnaamzoekopdracht — identiteit is alleen lokaal.',
  search_format_err: 'Formaat: ZN-123456',
  search_resolving: 'Code oplossen…',
  search_invalid_code: 'Ongeldige code — vraag om een bijgewerkte ZN- (open ZION opnieuw op het apparaat van de andere persoon)',
  search_session_found: 'sessie gevonden',
  search_tap_to_send: 'Tik om verzoek te verzenden',
  search_socket_not_ready: 'Socket-sessie niet gereed',
  search_request_sent: 'Verzoek verzonden ✓',
  search_request_failed: 'Verzenden mislukt',
  license_title: 'Web- / iPhone-licentieactivatie',
  license_heading: 'Licentie',
  license_heading_updated: 'Bijgewerkte voorwaarden',
  license_hint: 'Voer de op zionyx.ch gekochte code <strong>ZION-XXXX-XXXX-XXXX</strong> in. Deze wordt gekoppeld aan deze browser (lokale sleutel).',
  license_code_label: 'Licentiecode',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Licentie activeren',
  license_beta_hint: 'Webbèta: gebruik een speciale iPhone-licentie indien beschikbaar.',
  license_accept_legal_err: 'Accepteer Privacy en Gebruiksvoorwaarden om door te gaan',
  license_need_code: 'Voer de licentiecode in',
  license_verifying: 'Licentie controleren…',
  license_invalid_or_used: 'Ongeldige licentie of al gebruikt op een ander apparaat',
  license_active: 'Licentie actief ✓',
  license_err_not_found: 'Ongeldige licentiecode',
  license_err_conflict: 'Licentie al gekoppeld aan een ander apparaat',
  license_err_rate_limit: 'Te veel pogingen — wacht een minuut',
  license_err_generic: 'Licentiefout',
  link_device_title: 'Nieuw apparaat koppelen',
  link_device_hint: 'Open op je <strong>PC</strong> Instellingen → Nieuw apparaat koppelen: je ziet de <strong>groene QR</strong>. Scan deze hieronder (camera of foto).',
  link_device_status_ready: '[GEREED]',
  link_device_upload_label: 'QR-foto uploaden',
  link_device_btn_camera: 'Camera / galerij openen',
  link_device_placeholder: 'QR-link of payload…',
  link_device_btn_send_vault: 'Versleutelde kluis verzenden',
  link_device_err_invalid_qr: 'Ongeldige of verlopen QR.',
  link_device_status_invalid: '[ONGELDIGE QR]',
  link_device_status_sync_complete: '[SYNC VOLTOOID]',
  link_device_status_transfer_failed: '[OVERDRACHT MISLUKT]',
  link_device_status_qr_detected: '[QR GEDETECTEERD — OVERDRACHT...]',
  link_device_status_tap_camera: '[TIK OP DE GROENE KNOP — IPHONE-CAMERA]',
  link_device_status_use_camera_below: '[GEBRUIK CAMERA / GALERIJ HIERONDER]',
  link_device_status_point_camera: '[RICHT CAMERA OP PC-QR...]',
  link_device_status_decoding: '[QR DECODEREN...]',
  link_device_status_qr_not_found: '[QR NIET GEVONDEN]',
  link_device_status_decode_failed: '[DECODEREN MISLUKT]',
  link_device_status_opened_from_qr: '[GEOPEND VANUIT QR — STARTEN...]',
  link_recv_title: 'Koppelen vanaf telefoon',
  link_recv_hint_compact:
    'Scan deze <strong>groene QR</strong> met je telefoon (Instellingen → Nieuw apparaat koppelen). De vault is end-to-end versleuteld.',
  link_recv_hint_auth:
    'Heb je ZION al op je telefoon? Scan deze QR met de <strong>Camera</strong> — de pc koppelt en logt automatisch in.',
  link_recv_qr_alt: 'QR voor apparaatkoppeling',
  link_recv_copy_link: 'Link kopiëren',
  link_recv_awaiting: '[WACHTEN OP TELEFOONSCAN — TUNNEL OPEN...]',
  link_recv_failed: '[KOPPELEN MISLUKT]',
  link_recv_tunnel_lost:
    'Tunnel onderbroken — de vault is mogelijk nog onderweg. Scan de QR opnieuw.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Nieuw versleuteld bericht',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Vergankelijk bericht',
  force_update_title: '🚨 VERPLICHT KRITIEKE UPDATE — Om Zionyx veilig te blijven gebruiken, moet je de nieuwste versie downloaden.',
  force_update_desc: 'De geïnstalleerde client is niet compatibel met de minimale versie die actief is op de server.',
  force_update_versions: 'Geïnstalleerd: v{current} · Vereist: v{required}',
  force_update_btn: 'NU BIJWERKEN',
}
